const TRUTHY = ['1', 'true', 'yes', 'on'];
const FALSY = ['0', 'false', 'no', 'off'];

function shouldAllowConsole() {
  if (typeof process === 'undefined') {
    return false;
  }

  const explicit = String(process.env.GATSBY_ENABLE_CONSOLE_LOGS || '').trim().toLowerCase();
  if (TRUTHY.includes(explicit)) return true;
  if (FALSY.includes(explicit)) return false;

  return false;
}

(function applyConsoleFilters() {
  if (typeof console === 'undefined') {
    return;
  }
  if (shouldAllowConsole()) {
    return;
  }

  const noop = () => {};
  ['log', 'debug', 'info', 'warn', 'error'].forEach(method => {
    if (typeof console[method] === 'function') {
      console[method] = noop;
    }
  });
})();
